"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mutation = Mutation;
exports.Query = Query;
exports.Subscription = Subscription;
Object.defineProperty(exports, "ApolloConsumer", {
  enumerable: true,
  get: function get() {
    return _reactCommon.ApolloConsumer;
  }
});
Object.defineProperty(exports, "ApolloProvider", {
  enumerable: true,
  get: function get() {
    return _reactCommon.ApolloProvider;
  }
});
Object.defineProperty(exports, "getApolloContext", {
  enumerable: true,
  get: function get() {
    return _reactCommon.getApolloContext;
  }
});
Object.defineProperty(exports, "resetApolloContext", {
  enumerable: true,
  get: function get() {
    return _reactCommon.resetApolloContext;
  }
});

var _reactCommon = require("@apollo/react-common");

var _reactHooks = require("@apollo/react-hooks");

var _propTypes = _interopRequireDefault(require("prop-types"));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function Query(props) {
  var children = props.children,
      query = props.query,
      options = __rest(props, ["children", "query"]);

  var result = (0, _reactHooks.useQuery)(query, options);
  return children && result ? children(result) : null;
}

(function (Query) {
  Query.propTypes = {
    client: _propTypes.default.object,
    children: _propTypes.default.func.isRequired,
    fetchPolicy: _propTypes.default.string,
    notifyOnNetworkStatusChange: _propTypes.default.bool,
    onCompleted: _propTypes.default.func,
    onError: _propTypes.default.func,
    pollInterval: _propTypes.default.number,
    query: _propTypes.default.object.isRequired,
    variables: _propTypes.default.object,
    ssr: _propTypes.default.bool,
    partialRefetch: _propTypes.default.bool,
    returnPartialData: _propTypes.default.bool
  };
})(Query || (exports.Query = Query = {}));

function Mutation(props) {
  var _a = (0, _reactHooks.useMutation)(props.mutation, props),
      runMutation = _a[0],
      result = _a[1];

  return props.children ? props.children(runMutation, result) : null;
}

(function (Mutation) {
  Mutation.propTypes = {
    mutation: _propTypes.default.object.isRequired,
    variables: _propTypes.default.object,
    optimisticResponse: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
    refetchQueries: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])), _propTypes.default.func]),
    awaitRefetchQueries: _propTypes.default.bool,
    update: _propTypes.default.func,
    children: _propTypes.default.func.isRequired,
    onCompleted: _propTypes.default.func,
    onError: _propTypes.default.func,
    fetchPolicy: _propTypes.default.string
  };
})(Mutation || (exports.Mutation = Mutation = {}));

function Subscription(props) {
  var result = (0, _reactHooks.useSubscription)(props.subscription, props);
  return props.children && result ? props.children(result) : null;
}

(function (Subscription) {
  Subscription.propTypes = {
    subscription: _propTypes.default.object.isRequired,
    variables: _propTypes.default.object,
    children: _propTypes.default.func,
    onSubscriptionData: _propTypes.default.func,
    onSubscriptionComplete: _propTypes.default.func,
    shouldResubscribe: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool])
  };
})(Subscription || (exports.Subscription = Subscription = {}));